import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface PromptTemplateDrawerFooterProps {
  isEditing: boolean
  onCancel: () => void
  onSubmit: () => void
}

/**
 * Footer with cancel and save actions for the prompt template drawer.
 */
export const PromptTemplateDrawerFooter = ({
  isEditing,
  onCancel,
  onSubmit,
}: PromptTemplateDrawerFooterProps): ReactNode => (
  <div className="prompt-template-drawer-footer flex justify-end gap-2 border-t px-6 py-4">
    <Button
      type="button"
      variant="outline"
      onClick={onCancel}
      className="prompt-template-drawer-cancel"
    >
      Cancel
    </Button>
    <Button type="button" onClick={onSubmit} className="prompt-template-drawer-save">
      {isEditing ? 'Save Changes' : 'Create Template'}
    </Button>
  </div>
)

PromptTemplateDrawerFooter.displayName = 'PromptTemplateDrawerFooter'
